import { z } from 'zod';
import { AttendeeResponseSchema } from '../communications/calendar.schemas';

/**
 * The buyer's answer on a Besichtigung changed to ACCEPTED, TENTATIVE or DECLINED (IMM-1068.2). One event per change;
 * a reset to NEEDS_ACTION publishes nothing. Ids, an enum and times only (ADR 0015 §PII).
 */
export const ViewingResponseChangedPayloadSchema = z.object({
  workspaceId: z.uuid(),
  organizationId: z.uuid(),
  appointmentId: z.uuid(),
  prospectId: z.uuid(),
  contactId: z.uuid(),
  // The member whose calendar holds the appointment.
  appointmentMemberId: z.uuid(),
  response: z.enum(['ACCEPTED', 'TENTATIVE', 'DECLINED']),
  previousResponse: AttendeeResponseSchema,
  // The row's change_count after this change: the identity of this change for the timeline and the decline e-mail.
  changeNumber: z.number().int().positive(),
  startsAt: z.iso.datetime(),
  isAllDay: z.boolean(),
  occurredAt: z.iso.datetime(),
});
export type ViewingResponseChangedPayload = z.infer<typeof ViewingResponseChangedPayloadSchema>;
